import { Link } from "react-router-dom";
import { useLanguage } from "@/contexts/LanguageContext";
import { PageContainer } from "@/components/flowly/PageContainer/PageContainer";
import { Button } from "@/components/flowly/infra/Button/Button";

export function LandingCTA() {
  const { t } = useLanguage();

  return (
    <section className="relative py-24 md:py-32 bg-card border-y border-border text-center overflow-hidden">
      {/* Glow effect */}
      <div className="absolute inset-0 bg-primary/5 blur-[120px] pointer-events-none" />

      <PageContainer>
        <div className="relative flex flex-col items-center gap-6">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight">
            {t.landing.finalCtaTitle}
          </h2>

          <p className="text-lg md:text-xl text-muted-foreground">
            {t.landing.finalCtaSubtitle}
          </p>

          {/* CTA button */}
          <Link to="/generate-product-catalog" className="mt-4">
            <Button variant="accent" className="px-8 py-4 text-base sm:px-12 sm:py-5 sm:text-xl">
              {t.landing.finalCtaButton}
            </Button>
          </Link>

          {/* Trust micro-copy */}
          <p className="text-sm text-muted-foreground">
            {t.landing.finalCtaTrust}
          </p>
        </div>
      </PageContainer>
    </section>
  );
}
